// extracted by mini-css-extract-plugin
export default {"form":"QwyKnue8","mobile":"mobile","row":"vUMBNjYu","field":"PYWZylsY","footer":"gL76vFRa","errorMessage":"dW5GxwSM"};